module.exports = __webpack_public_path__ + "img/D202010_1.1d859766.jpg";